// Ports design-system/homepage/Hero.jsx's two-phase brand->model picker onto a plain-JS web component.
(function () {
  'use strict';

  var CM_DEVICE_KEY = 'cm:device';
  var CM_DEVICE_VERSION = 3; // v2 always built /search filter URLs; v3 adds the coll shortcut, so stale v2 entries must not resolve as-is
  var PICKER_MAX_RESULTS = 10; // models-phase search: flat results cap before the "+N meer" overflow line

  // a renamed model metaobject keeps its GID but not its handle, so a stored selection is upgraded on read
  var LEGACY_MODEL_HANDLES = { 'airpods-pro-2': 'apple-airpods-pro-2' };
  // brand handle -> section id on /pages/welk-model-heb-ik; unlisted brands land on the generic Android section
  var CM_HELP_ANCHORS = { apple: 'iphone', samsung: 'samsung', google: 'google', xiaomi: 'xiaomi', oppo: 'oppo', oneplus: 'oneplus', 'nothing-phone': 'nothing', motorola: 'motorola' };

  // words shoppers tack onto a model name: they may confirm a match but never veto one (A94 and A94 5G are both real models)
  var SOFT_WORDS = ['5g', '4g', 'hoes', 'hoesje', 'hoesjes', 'case', 'cover', 'telefoon', 'telefoonhoesje'];

  function normalizeQuery(s) {
    var out = String(s || '').toLowerCase();
    if (out.normalize) out = out.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return out.replace(/\+/g, ' plus ');
  }
  // "reno 16f", "reno16 f" and "Reno16 F 5G" must all meet: compare with spaces/punctuation stripped (Hannah 2026-09-29)
  function compactQuery(s) {
    return normalizeQuery(s).replace(/[^a-z0-9]+/g, '');
  }
  function queryWords(s) {
    return normalizeQuery(s).split(/[^a-z0-9]+/).filter(Boolean);
  }
  // one substitution, insertion, deletion or adjacent swap ("iphnoe", "samsnug", "galxy")
  function oneEdit(a, b) {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0;
    while (i < a.length && i < b.length && a[i] === b[i]) i++;
    if (a.length === b.length) {
      if (a.slice(i + 1) === b.slice(i + 1)) return true;
      return a[i] === b[i + 1] && a[i + 1] === b[i] && a.slice(i + 2) === b.slice(i + 2);
    }
    return a.length > b.length ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }
  // digits never get typo slack, so "a54" can't surface the A55
  function typoWord(token) {
    return /^[a-z]{4,}$/.test(token);
  }

  // tier 4 lets "a" match inside "galaxy" (it put the S9 first for "samsung a"), so only tiers 1-3 may be pre-selected
  var PRESELECT_MAX_TIER = 3;

  // tier 1 exact, 2 contiguous, 3 words start label words, 4 words anywhere, 5 typos (only when 1-4 are empty); window.CMDeviceSearch for tests
  function rankDevices(query, items) {
    var q = compactQuery(query);
    if (!q) return [];
    var tokens = queryWords(query);
    var hard = tokens.filter(function (t) { return SOFT_WORDS.indexOf(t) === -1; });
    var soft = tokens.filter(function (t) { return SOFT_WORDS.indexOf(t) !== -1; });
    function tierOf(label, typos) {
      var c = compactQuery(label);
      if (c === q) return 1;
      if (c.indexOf(q) !== -1) return 2;
      if (!hard.length) return 0;
      var lw = queryWords(label);
      var startsWord = function (t) { return lw.some(function (w) { return w.indexOf(t) === 0; }); };
      if (hard.every(startsWord)) return 3;
      if (hard.every(function (t) { return c.indexOf(t) !== -1; })) return 4;
      if (!typos) return 0;
      var near = function (t) { return typoWord(t) && lw.some(function (w) { return oneEdit(t, w); }); };
      return hard.every(function (t) { return c.indexOf(t) !== -1 || near(t); }) ? 5 : 0;
    }
    function collect(typos) {
      var out = [];
      items.forEach(function (item, index) {
        var tier = tierOf(item.label, typos);
        if (!tier) return;
        var c = compactQuery(item.label);
        var softHits = soft.filter(function (t) { return c.indexOf(t) !== -1; }).length;
        // word count, not characters: "Pixel 11" must not trail "Pixel 7", while "iPhone 15" still leads "iPhone 15 Pro"
        out.push({ item: item, tier: tier, soft: softHits, group: item.group || 0, len: queryWords(item.label).length, index: index });
      });
      return out;
    }
    var hits = collect(false);
    if (!hits.length) hits = collect(true);
    hits.sort(function (a, b) {
      return a.tier - b.tier || b.soft - a.soft || a.group - b.group || a.len - b.len || a.index - b.index;
    });
    return hits.map(function (h) { return { item: h.item, tier: h.tier }; });
  }

  // splits a display label into runs, flagging the words the query hit so the list can bold them
  function markDevice(label, query) {
    var tokens = queryWords(query);
    var q = compactQuery(query);
    return String(label).split(/(\s+)/).filter(Boolean).map(function (part) {
      var w = compactQuery(part);
      var hit = !!w && (
        (w.length >= 2 && q.indexOf(w) !== -1) ||
        tokens.some(function (t) {
          return t === w || (t.length >= 2 && w.indexOf(t) !== -1) || (typoWord(t) && oneEdit(t, w));
        })
      );
      return { text: part, hit: hit };
    });
  }

  // Enter may only pick when the text names a model: an exact name, or a word-start match with a digit ("samsung a" has 30 A models, none a fair guess)
  function preselectDevice(query, ranked) {
    if (!ranked.length) return false;
    return ranked[0].tier === 1 || (ranked[0].tier <= PRESELECT_MAX_TIER && /\d/.test(query));
  }

  var CMDeviceSearch = { rank: rankDevices, mark: markDevice, preselect: preselectDevice, preselectMaxTier: PRESELECT_MAX_TIER };
  if (typeof window !== 'undefined') window.CMDeviceSearch = CMDeviceSearch;
  if (typeof module !== 'undefined' && module.exports) module.exports = CMDeviceSearch;
  if (typeof document === 'undefined') return;

  // localStorage-backed device selection; get() is version-checked and never throws.
  var CMDevice = {
    canonicalHandle: function (handle) {
      return LEGACY_MODEL_HANDLES[handle] || handle;
    },
    get: function () {
      try {
        var raw = localStorage.getItem(CM_DEVICE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== CM_DEVICE_VERSION) return null;
        if (parsed.handle && LEGACY_MODEL_HANDLES[parsed.handle]) {
          parsed.handle = LEGACY_MODEL_HANDLES[parsed.handle];
        }
        return parsed;
      } catch (err) {
        return null;
      }
    },
    set: function (obj) {
      var value = Object.assign({}, obj, { v: CM_DEVICE_VERSION, ts: Date.now() });
      try {
        localStorage.setItem(CM_DEVICE_KEY, JSON.stringify(value));
      } catch (err) {
        // storage unavailable (private mode / quota) — still notify listeners for this tab
      }
      document.dispatchEvent(new CustomEvent('cm:device:change', { detail: value }));
      return value;
    },
    clear: function () {
      try {
        localStorage.removeItem(CM_DEVICE_KEY);
      } catch (err) {
        // storage unavailable — ignore, still notify listeners
      }
      document.dispatchEvent(new CustomEvent('cm:device:change', { detail: null }));
    },
  };
  // PLP "Dit is mijn apparaat": look the page device up in cm-models.json and save it through the one store
  CMDevice.saveByHandle = function (rawHandle, deviceUrl) {
    var handle = CMDevice.canonicalHandle(rawHandle);
    return loadModels().then(function (data) {
      var brands = data.brands || [];
      for (var i = 0; i < brands.length; i++) {
        var brand = brands[i];
        var models = (data.models || {})[brand.handle] || [];
        for (var j = 0; j < models.length; j++) {
          var model = models[j];
          if (model.handle !== handle) continue;
          return CMDevice.set({
            handle: model.handle,
            name: brand.handle === 'overig' ? model.label : brand.name + ' ' + model.label,
            brand: brand.name,
            brandHandle: brand.handle,
            gid: model.gid,
            filterValue: model.fv,
            fvs: model.fvs || [model.fv],
            coll: model.coll || '',
            url: deviceUrl || window.location.pathname,
            type: model.type || 'phone',
          });
        }
      }
      return null;
    });
  };
  window.CMDevice = CMDevice;

  // Lazy singleton fetch of cm-models.json; rejects on failure so callers can render their own error state.
  var modelsPromise = null;
  var modelsData = null; // the resolved payload, for code that runs after a list built from it is already on screen
  function loadModels() {
    if (!modelsPromise) {
      modelsPromise = fetch(window.cmModelsUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('cm-models fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          modelsData = data;
          return data;
        })
        .catch(function (err) {
          modelsPromise = null; // allow a retry on the next call
          throw err;
        });
    }
    return modelsPromise;
  }

  class CmDeviceFinderElement extends HTMLElement {
    constructor() {
      super();
      // module-level counter, not variant/section prefix — Theme Editor can duplicate this section
      this.uid = 'cmdf-' + (CmDeviceFinderElement.__uid = (CmDeviceFinderElement.__uid || 0) + 1);
      this.variant = this.dataset.variant;
      this.filterParam = this.dataset.filterParam;
      this.searchUrl = this.dataset.searchUrl;
      this.collectionsUrl = this.dataset.collectionsUrl || '/collections';
      this.titleModelsTemplate = this.dataset.titleModels || '%BRAND%';
      this.strNoResults = this.dataset.strNoResults || '';
      this.strLoadError = this.dataset.strLoadError || '';
      this.strModelSearchPlaceholder = this.dataset.strModelSearchPlaceholder || '';
      this.strModelSearchOverflow = this.dataset.strModelSearchOverflow || '';
      this.strNieuw = this.dataset.strNieuw || '';
      this.strQuickNav = this.dataset.strQuickNav || '';
      this.strLoading = this.dataset.strLoading || '';
      this.strChange = this.dataset.strChange || '';
      this.typeLabels = {};
      try { this.typeLabels = JSON.parse(this.dataset.typeLabels || '{}'); } catch (e) {}

      this.phaseBrands = this.querySelector('[data-cm-phase="brands"]');
      this.phaseModels = this.querySelector('[data-cm-phase="models"]');
      this.modelSub = this.phaseModels ? this.phaseModels.querySelector('.cm-finder__sub') : null;
      this.modelsHeading = this.querySelector('[data-cm-models-heading]');
      this.modelTabs = this.querySelector('[data-cm-model-tabs]');
      this.tabpanel = this.querySelector('[data-cm-tabpanel]');
      this.modelStatus = this.querySelector('[data-cm-model-status]');
      this.backButton = this.querySelector('.cm-finder__back');
      this.modelHint = this.querySelector('.cm-finder__hint');
      this.modelHintLine = this.querySelector('[data-cm-hint]');
      this.modelNotListed = this.querySelector('.cm-finder__not-listed');
      this.confirmRow = this.querySelector('[data-cm-confirm]');
      this.confirmChange = this.querySelector('[data-cm-confirm-change]');

      // hero+panel coexist and Theme Editor can duplicate the section — a static heading id would collide and aria-labelledby resolve to the wrong instance
      if (this.modelsHeading) this.modelsHeading.id = this.uid + '-models-heading';
      // tab aria-controls targets this wrapper
      if (this.tabpanel) this.tabpanel.id = this.uid + '-panel';

      this.globalSearchInput = this.querySelector('.cm-finder__search');
      this.globalSearchResults = this.querySelector('.cm-finder__search-results');
      this.searchGo = this.querySelector('[data-cm-search-go]');
      this.searchOptions = []; // { brand, model } per rendered option, index-aligned with the list
      this.searchActive = -1; // highlighted option; -1 = none (typo-only results are never pre-selected)
      this.searchQueryShown = null; // the query the open list was built for, so Enter never acts on a stale list

      this.allToggle = this.querySelector('.cm-brand-tile--all');
      this.moreTiles = this.querySelectorAll('.cm-brand-tile--more');

      this.currentBrand = null; // { handle, name }
      this.currentModels = null; // cached model list for the current brand
      this.distinctTypes = []; // ordered types present for the current brand
      this.showTabs = false; // ≥2 types and not the 'overig' catch-all
      this.activeType = null;
      this.modelPicker = null; // search+chips+list surface, reused across tab switches so focus/trap snapshot stays valid
      this.modelSearchInput = null;
      this.modelChipRow = null;
      this.modelList = null;
      this.modelScroll = null;
      this.groupHeaders = []; // group label -> header <li>, for chip scroll targets
      this.searchQuery = '';
      this.loadSeq = 0; // request generation token — a stale brand's callback bails
      this.lastBrandTile = null; // brand tile that opened the model phase, for focus return
      this.heroCta = null; // .cm-hero-device-cta relocated into the confirm row while collapsed

      this.bindBrandTiles();
      this.bindAllToggle();
      this.bindGlobalSearch();
      this.bindModelPhase();
      // the inline hero script may already have painted a returning visitor's picked state
      if (this.variant === 'hero' && this.isPicked()) this.adoptPicked(CMDevice.get());
    }

    connectedCallback() {
      // counts come from the same cm-models.json the picker uses; deferred so it never competes with the first paint
      var fill = () => this.hydrateBrandCounts();
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fill);
      else setTimeout(fill, 1200);
      if (this.variant === 'hero' && !this.onDeviceCleared) {
        this.onDeviceCleared = (event) => {
          if (!event.detail && this.isPicked()) this.resetHero();
        };
        document.addEventListener('cm:device:change', this.onDeviceCleared);
      }
    }

    isPicked() {
      return !!this.confirmRow && !this.confirmRow.classList.contains('hidden');
    }

    brandTile(handle) {
      var tiles = this.querySelectorAll('.cm-brand-tile[data-brand-handle]');
      for (var i = 0; i < tiles.length; i++) if (tiles[i].dataset.brandHandle === handle) return tiles[i];
      return null;
    }

    // take over a picked state painted before this element upgraded; the model list itself loads only if wijzig asks for it
    adoptPicked(device) {
      if (!device) {
        this.resetHero();
        return;
      }
      this.currentBrand = { handle: device.brandHandle, name: device.brand };
      this.lastBrandName = device.brand;
      this.lastBrandTile = this.brandTile(device.brandHandle);
      this.heroCta = this.confirmRow.querySelector('.cm-hero-device-cta');
    }

    // a saved model that left cm-models.json (delisted, no stock) is forgotten rather than offered as a dead link
    dropStaleDevice(data) {
      var saved = CMDevice.get();
      if (!saved || !saved.brandHandle) return;
      var models = (data.models || {})[saved.brandHandle] || [];
      if (!models.some(function (m) { return m.handle === saved.handle; })) CMDevice.clear();
    }

    // §6: each brand tile carries its model count; a brand missing from the data simply keeps no count
    hydrateBrandCounts() {
      if (this.brandCountsDone) return;
      this.brandCountsDone = true;
      loadModels()
        .then((data) => {
          this.dropStaleDevice(data);
          var counts = {};
          (data.brands || []).forEach(function (brand) {
            var models = (data.models || {})[brand.handle];
            counts[brand.handle] = typeof brand.count === 'number' ? brand.count : (models ? models.length : 0);
          });
          this.querySelectorAll('.cm-brand-tile[data-brand-handle]').forEach((tile) => {
            var count = counts[tile.dataset.brandHandle];
            if (!count) return;
            var span = tile.querySelector('.cm-brand-tile__count');
            if (!span) {
              span = document.createElement('span');
              span.className = 'cm-brand-tile__count';
              tile.appendChild(span);
            }
            span.textContent = count;
          });
        })
        .catch(function () {});
    }

    bindBrandTiles() {
      this.querySelectorAll('.cm-brand-tile[data-brand-handle]').forEach((tile) => {
        tile.addEventListener('click', () => this.pickBrand(tile.dataset.brandHandle, tile.dataset.brandName, tile));
      });
    }

    bindAllToggle() {
      if (!this.allToggle) return;
      // §6 step 1: the panel is a dedicated overlay, so every brand is on screen at once — the "+" toggle only earns its place in the one-row hero strip
      if (this.variant === 'panel') {
        this.moreTiles.forEach((tile) => tile.classList.remove('hidden'));
        this.allToggle.classList.add('hidden');
        return;
      }
      this.allToggle.addEventListener('click', () => {
        this.moreTiles.forEach((tile) => tile.classList.remove('hidden'));
        this.allToggle.classList.add('hidden');
      });
    }

    // combobox: live list while typing, first exact-enough hit pre-selected, Enter/search key/green button take the highlighted row
    bindGlobalSearch() {
      var input = this.globalSearchInput;
      var list = this.globalSearchResults;
      if (!input || !list) return;
      list.id = this.uid + '-search-results';
      list.setAttribute('role', 'listbox');
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', list.id);
      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('focus', () => {
        loadModels().catch(function () {});
        if (list.hidden && input.value.trim().length >= 2) this.updateGlobalSearch();
      });
      input.addEventListener('input', () => this.updateGlobalSearch());
      input.addEventListener('keydown', (event) => this.onGlobalSearchKeydown(event));
      // details-modal closes the panel on Escape keyup; an Escape that only closed the list must not reach it
      input.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.escapeClosedList) {
          event.stopPropagation();
          this.escapeClosedList = false;
        }
      });
      if (this.searchGo) this.searchGo.addEventListener('click', () => this.submitGlobalSearch());
      // pointerdown, not focusout: iOS never moves focus onto a tapped option, so focusout would close the list before the tap lands
      document.addEventListener('pointerdown', (event) => {
        if (!list.hidden && !input.parentNode.contains(event.target)) this.closeGlobalSearch(false);
      });
    }

    updateGlobalSearch() {
      var query = this.globalSearchInput.value.trim();
      if (query.length < 2) {
        this.closeGlobalSearch(false);
        return Promise.resolve();
      }
      return loadModels()
        .then((data) => {
          // a slow first fetch must not paint results for text the shopper has since changed
          if (this.globalSearchInput.value.trim() === query) this.renderGlobalSearchResults(data, query);
        })
        .catch(() => this.renderSearchListMessage(this.globalSearchResults, this.strLoadError));
    }

    renderGlobalSearchResults(data, query) {
      var items = [];
      (data.brands || []).forEach((brand, group) => {
        ((data.models || {})[brand.handle] || []).forEach((model) => {
          items.push({ label: brand.name + ' ' + model.label, group: group, brand: brand, model: model });
        });
      });
      var ranked = CMDeviceSearch.rank(query, items).slice(0, 12);
      var list = this.globalSearchResults;
      this.searchOptions = [];
      this.searchQueryShown = query;
      if (!ranked.length) {
        this.renderSearchListMessage(list, this.strNoResults);
        this.appendNotListedRow(list);
        this.setSearchActive(-1);
        return;
      }
      list.textContent = '';
      ranked.forEach((hit, i) => {
        var item = hit.item;
        var li = document.createElement('li');
        li.id = this.uid + '-option-' + i;
        li.className = 'cm-finder__search-option';
        li.setAttribute('role', 'option');
        var shown = item.brand.handle === 'overig' ? item.model.label : item.label;
        CMDeviceSearch.mark(shown, query).forEach(function (part) {
          if (!part.hit) {
            li.appendChild(document.createTextNode(part.text));
            return;
          }
          var strong = document.createElement('strong');
          strong.textContent = part.text;
          li.appendChild(strong);
        });
        li.addEventListener('click', () => this.pickFromSearch(item.model, item.brand));
        // the highlight follows the pointer so it never disagrees with what a click will pick
        li.addEventListener('pointermove', () => {
          if (this.searchActive !== i) this.setSearchActive(i);
        });
        list.appendChild(li);
        this.searchOptions.push({ brand: item.brand, model: item.model });
      });
      list.hidden = false;
      this.globalSearchInput.setAttribute('aria-expanded', 'true');
      this.setSearchActive(CMDeviceSearch.preselect(query, ranked) ? 0 : -1);
    }

    renderSearchListMessage(listEl, message) {
      listEl.textContent = '';
      var li = document.createElement('li');
      li.className = 'cm-finder__search-empty';
      li.setAttribute('role', 'presentation');
      li.textContent = message;
      listEl.appendChild(li);
      listEl.hidden = false;
      if (listEl === this.globalSearchResults) this.globalSearchInput.setAttribute('aria-expanded', 'true');
    }

    appendNotListedRow(listEl) {
      if (!this.modelNotListed) return;
      var li = document.createElement('li');
      li.className = 'cm-finder__search-empty';
      li.setAttribute('role', 'presentation');
      var a = document.createElement('a');
      a.className = 'cm-finder__search-help';
      a.href = this.modelNotListed.getAttribute('href');
      a.textContent = this.modelNotListed.textContent.trim();
      li.appendChild(a);
      listEl.appendChild(li);
    }

    setSearchActive(index, reveal) {
      var list = this.globalSearchResults;
      var options = list.querySelectorAll('[role="option"]');
      this.searchActive = index;
      options.forEach(function (opt, i) {
        opt.classList.toggle('is-active', i === index);
        opt.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      var active = index >= 0 ? options[index] : null;
      if (active) this.globalSearchInput.setAttribute('aria-activedescendant', active.id);
      else this.globalSearchInput.removeAttribute('aria-activedescendant');
      // scroll the list, never the page: scrollIntoView would drag a below-the-fold list into view on every keystroke
      if (active && reveal) {
        var top = active.offsetTop;
        var bottom = top + active.offsetHeight;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
      }
    }

    onGlobalSearchKeydown(event) {
      var open = !this.globalSearchResults.hidden;
      var count = this.searchOptions.length;
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp': {
          event.preventDefault();
          if (!open) {
            this.updateGlobalSearch();
            return;
          }
          if (!count) return;
          var next = this.searchActive + (event.key === 'ArrowDown' ? 1 : -1);
          if (next < 0) next = count - 1;
          else if (next >= count) next = 0;
          this.setSearchActive(next, true);
          return;
        }
        case 'Enter':
          event.preventDefault();
          this.submitGlobalSearch();
          return;
        case 'Escape':
          if (!open) return;
          event.preventDefault();
          this.escapeClosedList = true;
          this.closeGlobalSearch(false);
          return;
        case 'Tab':
          this.closeGlobalSearch(false);
          return;
      }
    }

    // re-rank unless the open list was built for exactly this text: acting on a leftover list lands on the wrong phone
    submitGlobalSearch() {
      var input = this.globalSearchInput;
      var query = input.value.trim();
      var act = () => {
        var option = this.searchActive >= 0 ? this.searchOptions[this.searchActive] : null;
        if (option) this.pickFromSearch(option.model, option.brand);
        else input.focus();
      };
      if (query.length < 2) {
        input.focus();
        return;
      }
      if (this.searchQueryShown === query && !this.globalSearchResults.hidden) act();
      else this.updateGlobalSearch().then(act);
    }

    closeGlobalSearch(clear) {
      var list = this.globalSearchResults;
      if (!list) return;
      list.hidden = true;
      list.textContent = '';
      this.searchOptions = [];
      this.searchActive = -1;
      this.searchQueryShown = null;
      this.globalSearchInput.setAttribute('aria-expanded', 'false');
      this.globalSearchInput.removeAttribute('aria-activedescendant');
      if (clear) this.globalSearchInput.value = '';
    }

    // the panel navigates like any panel pick; the hero lands on the same picked state as brand → model, that brand's list behind wijzig
    pickFromSearch(model, brand) {
      this.closeGlobalSearch(true);
      if (this.variant !== 'hero' || !modelsData) {
        this.pickModel(model, brand);
        return;
      }
      this.prepareBrand(brand.handle, brand.name, this.brandTile(brand.handle));
      this.openBrand(modelsData, model.type);
      this.showPhase('models', false);
      this.pickModel(model, brand);
    }

    bindModelPhase() {
      if (this.backButton) {
        this.backButton.addEventListener('click', () => this.showPhase('brands'));
      }
      if (this.confirmChange) {
        this.confirmChange.textContent = this.strChange;
        this.confirmChange.addEventListener('click', () => this.expandHeroModels());
      }
    }

    pickBrand(handle, name, tile, preferType) {
      var seq = this.prepareBrand(handle, name, tile);
      this.showPhase('models');
      // fill the click→select gap: current-brand loading is set synchronously here, so it's never a stale generation
      this.showLoadingStatus();
      loadModels()
        .then((data) => {
          if (seq !== this.loadSeq) return;
          this.openBrand(data, preferType);
          // explicit rAF: a sync/null rebuild can beat showPhase's rAF, snapshot the hidden brand tile as activeElement, and break the trap
          this.focusPickerEntry(true);
        })
        .catch(() => {
          if (seq !== this.loadSeq) return;
          this.showLoadError();
          // error DOM changed the panel's focusable set — re-snapshot the trap
          this.focusPickerEntry(true);
        });
    }

    // returns the new generation token: a late/failed callback for a prior brand must not overwrite this brand's UI
    prepareBrand(handle, name, tile) {
      this.currentBrand = { handle: handle, name: name };
      this.currentModels = null;
      this.lastBrandTile = tile || this.lastBrandTile;
      // clear the stage first: the previous brand's tabs/picker must not stay interactive while this fetch is pending
      if (this.modelTabs) {
        this.modelTabs.textContent = '';
        this.modelTabs.hidden = true;
        this.modelTabs.removeAttribute('role');
      }
      if (this.tabpanel) {
        this.tabpanel.removeAttribute('role');
        this.tabpanel.removeAttribute('aria-labelledby');
      }
      this.activeType = null;
      this.distinctTypes = [];
      this.hideModelStatus();
      this.removePicker();
      if (this.modelsHeading) {
        this.lastBrandName = name;
        this.modelsHeading.textContent = this.titleModelsTemplate.replace('%BRAND%', name);
      }
      // innerHTML is safe here: locale strings are theme content, not user input
      if (this.modelHintLine) {
        this.modelHintLine.innerHTML = handle === 'apple' ? this.modelHintLine.dataset.hintIos || '' : this.modelHintLine.dataset.hintAndroid || '';
        var helpLink = this.modelHintLine.querySelector('a');
        if (helpLink) helpLink.hash = CM_HELP_ANCHORS[handle] || 'android';
      }
      return ++this.loadSeq;
    }

    // tabs + picker for the current brand; preferType opens the tab of a model already chosen (search pick, wijzig)
    openBrand(data, preferType) {
      var handle = this.currentBrand.handle;
      this.currentModels = (data.models || {})[handle] || [];
      this.distinctTypes = [];
      this.currentModels.forEach((model) => {
        if (this.distinctTypes.indexOf(model.type) === -1) this.distinctTypes.push(model.type);
      });
      this.showTabs = this.distinctTypes.length >= 2 && handle !== 'overig';
      if (preferType && this.distinctTypes.indexOf(preferType) !== -1) this.activeType = preferType;
      else this.activeType = this.distinctTypes.indexOf('phone') !== -1 ? 'phone' : this.distinctTypes[0];
      this.hideModelStatus();
      this.renderTabs();
      // build the picker before the focus/trap snapshot so it lands in it
      this.buildPicker(this.activeType);
    }

    renderTabs() {
      var tabs = this.modelTabs;
      if (!tabs) return;
      tabs.textContent = '';
      if (!this.showTabs) {
        tabs.hidden = true;
        tabs.removeAttribute('role');
        this.updateTabpanelAria();
        return;
      }
      tabs.hidden = false;
      tabs.setAttribute('role', 'tablist');
      this.distinctTypes.forEach((type) => {
        var count = this.currentModels.filter((m) => m.type === type).length;
        var selected = type === this.activeType;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.id = this.uid + '-tab-' + type;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-controls', this.uid + '-panel');
        btn.setAttribute('aria-selected', selected ? 'true' : 'false');
        btn.tabIndex = selected ? 0 : -1;
        var label = document.createElement('span');
        label.textContent = this.typeLabels[type] || type;
        btn.appendChild(label);
        var countSpan = document.createElement('span');
        countSpan.className = 'cm-finder__tab-count';
        countSpan.textContent = count;
        btn.appendChild(countSpan);
        btn.addEventListener('click', () => this.setActiveType(type));
        btn.addEventListener('keydown', (event) => this.onTabKeydown(event));
        tabs.appendChild(btn);
      });
      this.updateTabpanelAria();
    }

    updateTabpanelAria() {
      if (!this.tabpanel) return;
      if (this.showTabs) {
        this.tabpanel.setAttribute('role', 'tabpanel');
        this.tabpanel.setAttribute('aria-labelledby', this.uid + '-tab-' + this.activeType);
      } else {
        this.tabpanel.removeAttribute('role');
        this.tabpanel.removeAttribute('aria-labelledby');
      }
    }

    setActiveType(type) {
      this.activeType = type;
      var activeBtn = null;
      this.modelTabs.querySelectorAll('[role="tab"]').forEach((btn) => {
        var sel = btn.id === this.uid + '-tab-' + type;
        btn.setAttribute('aria-selected', sel ? 'true' : 'false');
        btn.tabIndex = sel ? 0 : -1;
        if (sel) activeBtn = btn;
      });
      this.updateTabpanelAria();
      // reuse the same picker element (stable identity keeps the trap snapshot & focus valid); fresh type starts ungrouped-search-free
      this.buildPicker(type);
      if (activeBtn) activeBtn.focus();
      this.rebuildTrap(activeBtn, false);
    }

    onTabKeydown(event) {
      var types = this.distinctTypes;
      var i = types.indexOf(this.activeType);
      var next = null;
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          next = (i - 1 + types.length) % types.length;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          next = (i + 1) % types.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = types.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.setActiveType(types[next]);
    }

    // build (or refill) the search+chips+list picker; tab-filtered when tabs show, whole brand otherwise
    buildPicker(activeType) {
      if (!this.tabpanel || !this.currentModels) return;
      if (!this.modelPicker) {
        var picker = document.createElement('div');
        picker.className = 'cm-finder__picker';

        var searchWrap = document.createElement('div');
        searchWrap.className = 'cm-finder__picker-search-wrap';
        var searchIcon = document.createElement('span');
        searchIcon.className = 'cm-finder__picker-search-icon';
        searchIcon.setAttribute('aria-hidden', 'true');
        // static theme markup, not user input — innerHTML is the only way to inject an inline SVG here
        searchIcon.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';
        searchWrap.appendChild(searchIcon);
        var input = document.createElement('input');
        input.type = 'search';
        input.className = 'cm-finder__picker-search';
        input.placeholder = this.strModelSearchPlaceholder;
        input.setAttribute('aria-label', this.strModelSearchPlaceholder);
        input.autocomplete = 'off';
        input.addEventListener('input', () => this.onPickerSearchInput());
        searchWrap.appendChild(input);
        picker.appendChild(searchWrap);

        var chips = document.createElement('div');
        chips.className = 'cm-finder__picker-chips';
        chips.setAttribute('role', 'group');
        chips.setAttribute('aria-label', this.strQuickNav);
        chips.hidden = true;
        picker.appendChild(chips);

        var scroll = document.createElement('div');
        scroll.className = 'cm-finder__picker-scroll';
        var list = document.createElement('ul');
        list.className = 'cm-finder__picker-list';
        if (this.modelsHeading) list.setAttribute('aria-labelledby', this.modelsHeading.id);
        scroll.appendChild(list);
        picker.appendChild(scroll);

        this.tabpanel.appendChild(picker);
        this.modelPicker = picker;
        this.modelSearchInput = input;
        this.modelChipRow = chips;
        this.modelList = list;
        this.modelScroll = scroll;
      } else {
        this.modelSearchInput.value = '';
      }

      // a tab switch starts each type fresh in grouped view, not mid-search from the previous type
      this.searchQuery = '';
      this.renderPickerList(activeType);
    }

    renderPickerList(activeType) {
      var type = activeType || this.activeType;
      var models = this.showTabs ? this.currentModels.filter((m) => m.type === type) : this.currentModels;
      this.modelList.textContent = '';
      if (this.searchQuery) {
        this.modelChipRow.hidden = true;
        this.renderSearchRows(models, this.searchQuery);
      } else {
        this.renderGroupedRows(models);
      }
    }

    onPickerSearchInput() {
      this.searchQuery = this.modelSearchInput.value.trim().toLowerCase();
      this.renderPickerList();
    }

    renderGroupedRows(models) {
      var isOverig = this.currentBrand && this.currentBrand.handle === 'overig';
      var order = [];
      var byGroup = {};
      models.forEach((model) => {
        var g = isOverig ? '' : model.group;
        if (byGroup[g] === undefined) {
          byGroup[g] = [];
          order.push(g);
        }
        byGroup[g].push(model);
      });
      var showGroups = !isOverig;
      this.groupHeaders = [];
      if (showGroups && order.length > 1) {
        this.renderChips(order);
        this.modelChipRow.hidden = false;
      } else {
        this.modelChipRow.textContent = '';
        this.modelChipRow.hidden = true;
      }
      order.forEach((g, i) => {
        if (showGroups) {
          var header = document.createElement('li');
          header.className = 'cm-finder__picker-group-header';
          header.textContent = g;
          this.modelList.appendChild(header);
          this.groupHeaders[i] = header;
        }
        byGroup[g].forEach((model) => this.modelList.appendChild(this.buildModelRow(model)));
      });
    }

    renderChips(groups) {
      this.modelChipRow.textContent = '';
      groups.forEach((g, i) => {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cm-finder__picker-chip';
        chip.textContent = g;
        chip.addEventListener('click', () => this.scrollToGroup(i));
        this.modelChipRow.appendChild(chip);
      });
    }

    // instant jump under prefers-reduced-motion, smooth scroll otherwise (mirrors the finder's other reduced-motion handling)
    scrollToGroup(index) {
      var header = this.groupHeaders[index];
      if (!header || !this.modelScroll) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || typeof this.modelScroll.scrollTo !== 'function') {
        this.modelScroll.scrollTop = header.offsetTop;
      } else {
        this.modelScroll.scrollTo({ top: header.offsetTop, behavior: 'smooth' });
      }
    }

    renderSearchRows(models, query) {
      var brandName = this.currentBrand ? this.currentBrand.name : '';
      var items = models.map((model) => ({ label: brandName + ' ' + model.label, model: model }));
      var matches = CMDeviceSearch.rank(query, items).map((hit) => hit.item.model);
      if (!matches.length) {
        var empty = document.createElement('li');
        empty.className = 'cm-finder__picker-empty';
        empty.textContent = this.strNoResults;
        this.modelList.appendChild(empty);
        return;
      }
      var shown = matches.slice(0, PICKER_MAX_RESULTS);
      shown.forEach((model) => this.modelList.appendChild(this.buildModelRow(model)));
      var overflow = matches.length - shown.length;
      if (overflow > 0) {
        var overflowLi = document.createElement('li');
        overflowLi.className = 'cm-finder__picker-overflow';
        overflowLi.textContent = this.strModelSearchOverflow.replace('%COUNT%', overflow);
        this.modelList.appendChild(overflowLi);
      }
    }

    buildModelRow(model) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-finder__picker-row';
      var label = document.createElement('span');
      label.className = 'cm-finder__picker-row-label';
      label.textContent = model.label;
      btn.appendChild(label);
      if (model.nieuw) {
        var badge = document.createElement('span');
        badge.className = 'cm-finder__picker-badge';
        badge.textContent = this.strNieuw;
        btn.appendChild(badge);
      }
      btn.addEventListener('click', () => this.pickModel(model, this.currentBrand));
      li.appendChild(btn);
      return li;
    }

    // panel navigates away — lock the rows so a second click can't fire mid-navigation (mirrors the old select.disabled)
    lockPickerRows() {
      if (!this.modelList) return;
      this.modelList.querySelectorAll('button').forEach((b) => { b.disabled = true; });
    }

    removePicker() {
      if (this.modelPicker && this.modelPicker.parentNode) {
        this.modelPicker.parentNode.removeChild(this.modelPicker);
      }
      this.modelPicker = null;
      this.modelSearchInput = null;
      this.modelChipRow = null;
      this.modelList = null;
      this.modelScroll = null;
      this.groupHeaders = [];
      this.searchQuery = '';
    }

    hideModelStatus() {
      if (this.modelStatus) this.modelStatus.classList.add('hidden');
    }

    showLoadingStatus() {
      if (this.modelStatus) {
        this.modelStatus.textContent = this.strLoading;
        this.modelStatus.classList.remove('hidden');
      }
    }

    showLoadError() {
      this.removePicker();
      if (this.modelStatus) {
        this.modelStatus.textContent = this.strLoadError;
        this.modelStatus.classList.remove('hidden');
      }
    }

    // re-snapshot the details-modal focus trap after the panel's focusable set changes (phase / tab / collapse)
    rebuildTrap(target, defer) {
      if (this.variant !== 'panel') return;
      var run = () => {
        var modal = this.closest('details-modal');
        if (!modal || typeof trapFocus !== 'function') return;
        // 'open' lives on the inner <details>, and open() traps on its [tabindex="-1"] child — mirror both or this never fires / scopes wrong
        var details = modal.querySelector('details');
        if (!details || !details.hasAttribute('open')) return;
        var container = details.querySelector('[tabindex="-1"]') || modal;
        var focusTarget = target && container.contains(target)
          ? target
          : (document.activeElement && container.contains(document.activeElement) ? document.activeElement : container);
        trapFocus(container, focusTarget);
      };
      if (defer) requestAnimationFrame(run); else run();
    }

    // entering the models phase (fresh load or wijzig re-expand) sends focus to the search input; falls back to the back button while it's still loading/errored
    focusPickerEntry(defer) {
      var target = this.modelSearchInput || this.backButton;
      if (!target) return;
      if (this.variant === 'panel') {
        this.rebuildTrap(target, defer);
      } else if (defer) {
        requestAnimationFrame(() => target.focus());
      } else {
        target.focus();
      }
    }

    // moveFocus false: the caller places focus itself (a search pick focuses the picked CTA)
    showPhase(phase, moveFocus) {
      var showEl = phase === 'brands' ? this.phaseBrands : this.phaseModels;
      var hideEl = phase === 'brands' ? this.phaseModels : this.phaseBrands;
      var target = phase === 'brands' ? this.lastBrandTile : this.backButton;
      showEl && showEl.classList.remove('hidden');
      // move focus off the old phase BEFORE hiding it: Chrome scroll-fixups a hidden focused element and StickyHeader reads that scroll as scroll-down and closes the panel
      if (target && this.contains(document.activeElement)) target.focus({ preventScroll: true });
      hideEl && hideEl.classList.add('hidden');
      if (moveFocus === false) return;
      // defer: the show/hide class toggle must paint before getClientRects (in the trap) sees the new phase
      if (this.variant === 'panel') {
        this.rebuildTrap(target, true);
      } else if (target) {
        // hero has no modal trap — move focus into the revealed phase directly
        requestAnimationFrame(() => target.focus());
      }
    }

    buildFilterUrl(fvs) {
      var param = this.filterParam;
      // OR semantics: one filter param repeated per merged gid so an alias model's products all surface
      var params = fvs.map(function (fv) { return param + '=' + encodeURIComponent(fv); }).join('&');
      // collections over 5,000 products get no Shopify storefront filters; search has no such limit
      return this.searchUrl + '?q=*&type=product&' + params;
    }

    // a model with its own device collection (model.coll) links straight there; everything else falls back to the search filter URL
    buildDeviceUrl(model) {
      if (typeof model.coll === 'string' && model.coll) {
        return this.collectionsUrl + '/' + model.coll;
      }
      return this.buildFilterUrl(model.fvs);
    }

    // hero-only: after a pick, fold phase-2 into the picked confirmation; window.cmPicked (layout/theme.liquid) also paints it for a returning visitor
    collapseHeroModels(device) {
      if (this.variant !== 'hero' || !window.cmPicked) return;
      if (!this.phaseModels || this.phaseModels.classList.contains('hidden')) return;
      this.heroCta = window.cmPicked.hero(this, device);
      if (this.heroCta) this.heroCta.focus({ preventScroll: true });
    }

    // undo the confirmation; the CTA goes back outside the finder hidden, the model list replaces it until the next pick
    foldConfirm() {
      if (this.confirmRow) this.confirmRow.classList.add('hidden');
      if (this.heroCta && this.parentNode) {
        this.parentNode.appendChild(this.heroCta);
        this.heroCta.classList.add('hidden');
      }
      this.heroCta = null;
      [this.modelSub, this.modelTabs, this.tabpanel, this.modelHint, this.modelNotListed].forEach(function (el) {
        if (el) el.classList.remove('hidden');
      });
    }

    // wijzig: restore phase-2 and rebuild the picker so re-picking the same model still fires a row click
    expandHeroModels() {
      this.foldConfirm();
      if (this.currentModels) {
        if (this.modelsHeading && this.lastBrandName) {
          this.modelsHeading.textContent = this.titleModelsTemplate.replace('%BRAND%', this.lastBrandName);
        }
        this.buildPicker(this.activeType);
        this.focusPickerEntry(false);
        return;
      }
      // a returning visitor's picked state was painted without the list: load that brand now, on the saved model's tab
      var saved = CMDevice.get();
      if (saved && saved.brandHandle) this.pickBrand(saved.brandHandle, saved.brand, this.brandTile(saved.brandHandle), saved.type);
      else this.resetHero();
    }

    // back to the brand step when the saved device is gone (cleared, or no longer in cm-models.json)
    resetHero() {
      this.foldConfirm();
      this.showPhase('brands', false);
    }

    pickModel(model, brand) {
      var name = brand.handle === 'overig' ? model.label : brand.name + ' ' + model.label;
      var fvs = model.fvs || [model.fv];
      var device = CMDevice.set({
        handle: model.handle,
        name: name,
        brand: brand.name,
        brandHandle: brand.handle,
        gid: model.gid,
        filterValue: model.fv,
        fvs: fvs,
        coll: model.coll || '',
        url: this.buildDeviceUrl(model),
        type: model.type || 'phone',
      });
      if (this.variant === 'panel') {
        this.lockPickerRows();
        // go through details-modal's own close() so its body-click listener/focus-trap/scroll-lock unwind too
        var modal = this.closest('details-modal');
        if (modal && typeof modal.close === 'function') {
          modal.close(false);
        } else {
          var details = this.closest('details');
          if (details) details.removeAttribute('open');
        }
        // picking in the dropdown must have a visible payoff (50+ audience) — land on the device's collection
        window.location.href = device.url;
      } else {
        // hero stays open — fold phase-2 into the confirmation row (CTA already re-rendered by the change listener)
        this.collapseHeroModels(device);
      }
    }
  }

  customElements.define('cm-device-finder', CmDeviceFinderElement);

  // page hydrators below run wherever these data attributes exist, independent of any <cm-device-finder>

  function hydrateChips(device) {
    document.querySelectorAll('[data-cm-chip]').forEach((chip) => {
      if (!chip.dataset.cmBound) {
        chip.dataset.cmBound = '1';
        // one control, one action: the chip always toggles the dropdown, in every state and at every breakpoint
        chip.addEventListener('click', (event) => {
          event.preventDefault();
          // stop the bubble: details-modal attaches onBodyClick during open(), and this same click reaching body would instantly close the panel
          event.stopPropagation();
          var wrapper = document.getElementById('CmModelSearch');
          var summary = wrapper && wrapper.querySelector('summary');
          if (summary) {
            summary.click();
            // details-modal focuses the first <input> on open; on mobile that pops the keyboard over the brand grid — park focus on the container instead
            var inner = wrapper.querySelector('.cm-model-search__inner');
            if (inner && wrapper.hasAttribute('open')) {
              inner.focus({ preventScroll: true });
              // that first-input focus also scrolled the panel down to the model search, past the "Jouw apparaat" card
              inner.scrollTop = 0;
            }
          } else {
            window.location.href = '/' + '#cm-finder';
          }
        });
      }
      var label = chip.querySelector('.cm-device-chip__label');
      if (device) {
        // mobile bar wants "{device} · wijzig"; the header chip has no data-cm-suffix so it keeps just the name
        if (label) label.textContent = chip.dataset.cmSuffix ? device.name + ' ' + chip.dataset.cmSuffix : device.name;
        if (label && chip.hasAttribute('aria-label')) chip.setAttribute('aria-label', label.textContent);
        chip.setAttribute('href', device.url);
        chip.classList.add('cm-device-chip--set');
        chip.classList.remove('cm-device-chip--page');
      } else if (window.cmPageDevice && window.cmPageDevice.name) {
        // no saved device but the page itself is device-scoped — show that device without persisting it
        var pageDevice = window.cmPageDevice;
        if (label) label.textContent = chip.dataset.cmSuffix ? pageDevice.name + ' ' + chip.dataset.cmSuffix : pageDevice.name;
        if (label && chip.hasAttribute('aria-label')) chip.setAttribute('aria-label', label.textContent);
        chip.setAttribute('href', '#');
        chip.classList.add('cm-device-chip--page');
        chip.classList.remove('cm-device-chip--set');
      } else {
        if (label) label.textContent = chip.dataset.defaultLabel || (label ? label.textContent : '');
        if (label && chip.hasAttribute('aria-label')) chip.setAttribute('aria-label', label.textContent);
        chip.setAttribute('href', '#');
        chip.classList.remove('cm-device-chip--set');
        chip.classList.remove('cm-device-chip--page');
      }
    });
  }

  function hydrateRetitles(device) {
    document.querySelectorAll('[data-cm-retitle]').forEach((el) => {
      if (el.dataset.cmOriginal === undefined) {
        el.dataset.cmOriginal = el.textContent;
      }
      if (device) {
        el.textContent = (el.dataset.cmRetitle || '').replace('%DEVICE%', device.name);
      } else {
        el.textContent = el.dataset.cmOriginal;
      }
    });
  }

  function hydrateCtas(device) {
    document.querySelectorAll('[data-cm-device-cta]').forEach((el) => {
      if (device) {
        el.classList.remove('hidden');
        el.setAttribute('href', device.url);
        if (el.dataset.cmCta) el.textContent = el.dataset.cmCta.replace('%DEVICE%', device.name);
      } else {
        el.classList.add('hidden');
      }
    });
  }

  // panel "Jouw apparaat" card: the same picked block as the hero, drawn by window.cmPicked
  function hydrateAsides(device) {
    document.querySelectorAll('[data-cm-aside]').forEach((aside) => {
      var deviceCard = aside.querySelector('[data-cm-aside-device]');
      if (!deviceCard) return;
      if (device && window.cmPicked) window.cmPicked.card(deviceCard, device, aside.closest('cm-device-finder'));
      else deviceCard.classList.add('hidden');
    });
  }

  // rewrites the Hoesjes submenu into a device-specific type list and points Screenprotectors at the device; no-op without a saved device
  function hydrateMenu(device) {
    var configEl = document.getElementById('cm-device-menu-config');
    if (!configEl) return;
    if (!device) {
      // device cleared in-page: put the Liquid-rendered menu back instead of leaving the old device's list
      document.querySelectorAll('[data-cm-menu-hydrated]').forEach((ul) => {
        ul.innerHTML = ul.dataset.cmMenuOriginal || '';
        ul.removeAttribute('data-cm-menu-hydrated');
      });
      document.querySelectorAll('a[data-cm-orig-href]').forEach((a) => {
        a.setAttribute('href', a.dataset.cmOrigHref);
      });
      return;
    }
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      return;
    }
    var strings = config.strings || {};
    var sep = device.url.indexOf('?') === -1 ? '?' : '&';
    var isTablet = device.type === 'tablet';
    // product_type is translated per language; window.cmTypeFilter (layout/theme.liquid) holds this language's values
    var typeFilter = window.cmTypeFilter || function () { return ''; };
    var items = [
      {
        label: (strings.all_cases || '').replace('%DEVICE%', device.name),
        url: device.url + sep + typeFilter(isTablet ? 'tablet_case' : 'phone_case'),
      },
    ];
    (config.types || []).forEach((t) => {
      items.push({ label: t.label, url: device.url + sep + t.param + '=' + encodeURIComponent(t.value) });
    });
    var screenprotectorUrl = device.url + sep + typeFilter(isTablet ? 'tablet_protector' : 'phone_protector');

    // opens the finder chip; on mobile the drawer must close first or the finder panel renders behind it
    function onChangeDeviceClick(event) {
      event.preventDefault();
      // the same click bubbling to body would close the finder the chip just opened; close the menu that held the link instead
      event.stopPropagation();
      var drawer = event.currentTarget.closest('.menu-drawer');
      if (drawer) {
        var container = document.getElementById('Details-menu-drawer-container');
        if (container) container.removeAttribute('open');
      }
      var dropdown = event.currentTarget.closest('nav.header__inline-menu details');
      if (dropdown) dropdown.removeAttribute('open');
      var chip = document.querySelector('[data-cm-chip]');
      if (chip) chip.click();
    }

    // idempotent: always torn down and rebuilt from `items` rather than patched in place
    function fillList(ul, itemClass) {
      if (!ul.hasAttribute('data-cm-menu-hydrated')) ul.dataset.cmMenuOriginal = ul.innerHTML;
      ul.innerHTML = '';
      ul.setAttribute('data-cm-menu-hydrated', '1');
      items.forEach((item) => {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = itemClass;
        a.href = item.url;
        a.textContent = item.label;
        li.appendChild(a);
        ul.appendChild(li);
      });
      var changeLi = document.createElement('li');
      var changeA = document.createElement('a');
      changeA.className = itemClass;
      changeA.href = '#cm-finder';
      changeA.textContent = strings.change_device || '';
      changeA.addEventListener('click', onChangeDeviceClick);
      changeLi.appendChild(changeA);
      ul.appendChild(changeLi);
    }

    // matches the top-level <li> whose disclosure summary (or plain link) text is the menu's "Hoesjes" title
    function findLiByLabel(lis, label, path) {
      for (var i = 0; i < lis.length; i++) {
        var li = lis[i];
        var a = li.querySelector(':scope > a, :scope > details > summary a, :scope > details > summary');
        var href = (a && a.getAttribute && a.getAttribute('href')) || '';
        if (path && href.indexOf(path) !== -1) return li;
        var summary = li.querySelector('summary');
        var text = summary ? summary.textContent : ((li.querySelector(':scope > a') || {}).textContent || '');
        if (text.trim() === label) return li;
      }
      return null;
    }
    function isScreenprotectorLink(a) {
      var href = a.getAttribute('href') || '';
      return href.indexOf('/collections/screenprotectors') !== -1 || a.textContent.trim() === strings.screenprotectors_title;
    }

    var desktopNav = document.querySelector('nav.header__inline-menu');
    if (desktopNav) {
      var hoesjesLi = findLiByLabel(desktopNav.querySelectorAll(':scope > ul > li'), strings.hoesjes_title, '/collections/telefoonhoesjes');
      if (hoesjesLi) {
        var desktopUl = hoesjesLi.querySelector('ul.header__submenu');
        if (desktopUl) fillList(desktopUl, 'header__menu-item list-menu__item link link--text focus-inset caption-large');
      }
      desktopNav.querySelectorAll('a').forEach((a) => {
        if (isScreenprotectorLink(a)) {
          if (!a.dataset.cmOrigHref) a.dataset.cmOrigHref = a.getAttribute('href');
          a.setAttribute('href', screenprotectorUrl);
        }
      });
    }

    var drawerMenu = document.querySelector('.menu-drawer');
    if (drawerMenu) {
      var hoesjesDrawerLi = findLiByLabel(drawerMenu.querySelectorAll('ul.menu-drawer__menu.has-submenu > li'), strings.hoesjes_title, '/collections/telefoonhoesjes');
      if (hoesjesDrawerLi) {
        var innerSubmenu = hoesjesDrawerLi.querySelector('.menu-drawer__inner-submenu');
        var drawerUl = innerSubmenu ? innerSubmenu.querySelector('ul.menu-drawer__menu') : null;
        if (drawerUl) fillList(drawerUl, 'menu-drawer__menu-item link link--text list-menu__item focus-inset');
      }
      drawerMenu.querySelectorAll('a').forEach((a) => {
        if (isScreenprotectorLink(a)) {
          if (!a.dataset.cmOrigHref) a.dataset.cmOrigHref = a.getAttribute('href');
          a.setAttribute('href', screenprotectorUrl);
        }
      });
    }
  }

  // mirrors the dropdown's open state onto every chip's aria-expanded
  function bindChipExpanded() {
    var details = document.getElementById('CmModelSearch');
    if (!details || details.dataset.cmExpandedBound) return;
    details.dataset.cmExpandedBound = '1';
    details.addEventListener('toggle', function () {
      var expanded = details.hasAttribute('open') ? 'true' : 'false';
      document.querySelectorAll('[data-cm-chip]').forEach(function (chip) {
        chip.setAttribute('aria-expanded', expanded);
      });
    });
  }

  function refreshCmUI(device) {
    hydrateChips(device);
    hydrateRetitles(device);
    hydrateCtas(device);
    hydrateAsides(device);
    hydrateMenu(device);
    bindChipExpanded();
  }

  document.addEventListener('DOMContentLoaded', () => refreshCmUI(CMDevice.get()));
  document.addEventListener('cm:device:change', (event) => refreshCmUI(event.detail));
  window.addEventListener('storage', (event) => {
    if (event.key === CM_DEVICE_KEY) refreshCmUI(CMDevice.get());
  });
})();
